import { showToast } from 'services/utils';
import NestedRow from './NestedRow';
import { cloneDeep } from 'lodash';

const NestedRows = (props) => {
    const { columns, rows, commonStyle, config, errorRef } = props;

    const { onSubmit, renderRows } = config

    const handleBtnClick = (event, row, rowIndex, column, columnIndex, mainRowIndex) => {
        if (event === "delete") {
            if (onDelete !== true) {
                const beforeDelete = !!onDelete?.before ? onDelete?.before : false
                const afterDelete = !!onDelete?.after ? onDelete?.after : false
                if (beforeDelete !== false) {
                    beforeDelete(deleteRow, cloneDeep(row), rowIndex)
                } if (afterDelete !== false) {
                    deleteRow(rowIndex)
                    afterDelete(cloneDeep(row), rowIndex)
                } else {
                    deleteRow(rowIndex)
                }
            } else {
                deleteRow(rowIndex)
            }
        } else if (event === "submit") {
            // if (onSubmit?.checkESign == true) {
            //     let esignStatus = true
            //     columns?.forEach((col, i) => {
            //         if (col?.type === "esign") {
            //             const checkColData = (row?.[col?.uniqueName] !== "")
            //                 && (typeof row?.[col?.uniqueName] === "object")

            //             if (!checkColData && (multipleESign === false)
            //             ) {
            //                 esignStatus = false
            //                 showToast("E-Sign required", false)
            //                 return
            //             } else if (
            //                 !checkColData && (multipleESign !== false) && (col?.eSignStep === row?.currentESignStep)
            //             ) {
            //                 esignStatus = false
            //                 showToast(`E-Sign required in ${col?.name}`, false)
            //                 return
            //             }
            //         }
            //     })
            //     if (!esignStatus) {
            //         return
            //     }
            // }
            // const isValidate = onSubmit?.checkValidation ? checkValidation(row, rowIndex) : true
            // if (!isValidate) { return }
            if (onSubmit?.handler !== false) {
                onSubmit.handler(cloneDeep(row), mainRowIndex)
            } else {
                showToast("Submit function not provided !", false)
            }
        }
    }

    const setterHelperByRows = (data, dependancyFiiledData) => {
        const { column, path, mainRowIndex, row } = data
        const { handler = () => { } } = dependancyFiiledData

        rows?.forEach((loopRow, loopRowIndex) => {
            const updateRow = handler(cloneDeep(
                {
                    activeData: {
                        column,
                        path,
                        mainRowIndex,
                        row
                    },
                    currentData: {
                        rowIndex: loopRowIndex,
                        row: loopRow
                    }
                }
            ))
            rows[loopRowIndex] = updateRow
            renderRows?.rows?.[loopRowIndex]()
        })

    }


    return rows?.length > 0 ? (
        rows?.map((row, index) => {
            return (
                <NestedRow
                    columns={columns}
                    row={row}
                    commonStyle={commonStyle}
                    config={config}
                    index={index}
                    rows={rows}
                    helperFunction={{
                        handleBtnClick,
                        setterHelperByRows
                    }}
                    errorRef={errorRef}
                />
            );
        })
    ) : null;
};

export default NestedRows;
